import { HTMLAttributes } from 'preact/compat';
import { useState } from 'preact/hooks';

interface FallbackImageProps {
  fallback?: string;
  onLoad?: () => void;
}

export function FallbackImage({
  src,
  fallback,
  onLoad,
  ...props
}: HTMLAttributes<HTMLImageElement> & FallbackImageProps) {
  const [source, setSource] = useState(src);

  const handleError = () => fallback && setSource(fallback);

  return <img src={source} onLoad={onLoad} onError={handleError} {...props} />;
}
